import {toast} from "react-toastify";
import React, {useState} from "react";
import {useFormContext} from "react-hook-form";
import {IPaymentOffsetAvailablePayment} from "src/dtos/paymentOffset/IPaymentOffsetAvailablePayment";
import {PaymentOffsetService} from "src/services/paymentOffset/paymentOffsetService";
import {PaymentOffset} from "src/components/Shared/Settlements/PaymentOffset";

export const PurchaseOrderDetailPaymentOffsets = () => {
    const tableName = "paymentOffsets";
    const {getValues} = useFormContext();
    const [paymentOffsetAvailablePayments, setPaymentOffsetAvailablePayments] =
        useState<IPaymentOffsetAvailablePayment[]>([]);


    const handleRefreshAvailablePayment = async () => {
        const id = getValues("id");
        if (!id) {
            toast.warn("Please save document first");
            return;
        }

        const paymentOffsetService = new PaymentOffsetService();
        const result = await paymentOffsetService.getVendorPaymentOffset(id);
        console.log(result);
        setPaymentOffsetAvailablePayments(result);
    };

    const handleDoCreditPayment = () => {
    };

    return (
        <>
            <PaymentOffset
                selectedPayments={getValues(tableName) ?? []}
                availablePayments={paymentOffsetAvailablePayments}
                onDoCreditPayment={handleDoCreditPayment}
                onApplyChanges={() => {
                }}
                onRefreshAvailablePayments={handleRefreshAvailablePayment}
            />
        </>
    )
}